
export interface UpdatePaymentDetailsRequest {
    IsConsumerUpdated: boolean;
    IsPaymentDetailsUpdated: boolean;
    ContractNumber: string;
    ProgramCode: string;
    Amount: number;
    Consumer: MyAccountConsumer ;
    PaymentPlanCode: PaymentPlanCode;
    PaymentDetail?: MyAccountPaymentDetail;
    PaymentType: MyAccountPaymentType;
    RecurringAmount: number;
    ClientId: string;
    AssociateNumber: string;
    TrackingId: string;
}

export interface MyAccountConsumer {
    Address1: string;
    Address2: string;
    City: string;
    Country: string;
    Email: string;
    Id?: number;
    Name: string;
    ZipCode: string;
    PrimaryPhone?: string;
    SecondaryPhone?: string;
    State: string;
}

export interface MyAccountPaymentDetail {
    AccountNumber?: string;
    AccountType?: string;
    CvcCode: number;
    CardNumber: string;
    CheckNumber?: string;
    ExpirationMonth: number;
    ExpirationYear: number;
    MoneyOrderNumber: string;
    PaymentDay: number;
    PinNumber: number;
    ProfileStatus: string;
    RoutingNumber: string;
}

export enum  MyAccountPaymentType {
    CreditCard = 0,
    ECheck = 1
}

export enum PaymentPlanCode{
    EVERGREEN = -1,
    NONE = 0,
    SINGLEPAY = 1,
    TWOPAY = 2,
    THREEPAY = 3,
    FOURPAY = 4,
    FIVEPAY = 5,
    SIXPAY = 6,
    SEVENPAY = 7,
    EIGHTPAY = 8,
    NINEPAY = 9,
    TWELVEPAY = 12,
    EIGHTEENPAY = 18,
    TWENTYFOURPAY = 24,
    THIRTYSIXPAY = 36,
    FORTYEIGHTPAY = 48,
    SIXTYPAY = 60
}
